module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-hans-2-dark-30701c624a170cd66527f85c03513a7d.jpg";